// eslint-disable-next-line import/prefer-default-export
export const hasItems = type => ({ [type]: items }) => (items || []).length > 0;
